export type DragDepthEvent = 'enter' | 'leave' | 'reset'

export function dragDepthAfter(depth: number, event: DragDepthEvent): number {
  switch (event) {
    case 'enter': {
      return depth + 1
    }
    case 'leave': {
      return Math.max(0, depth - 1)
    }
    case 'reset': {
      return 0
    }
  }
}

export function mediaDragIsAvailable(depth: number, asset: { mediaType: string } | null): boolean {
  return depth > 0 && (asset?.mediaType === 'image' || asset?.mediaType === 'video')
}
